<template>
  <div>
    <div class="row bg-light pt-3 d-flex align-items-stretch">
      <div class="col">
        <mz-status></mz-status>
      </div>
      <div class="col">
        <mz-lifetime></mz-lifetime>
      </div>
    </div>
    <div class="row bg-light pt-3">
      <div class="col">
        <mz-vibration></mz-vibration>
      </div>
    </div>
    <div class="row bg-light pt-3">
      <div class="col">
        <mz-temperature></mz-temperature>
      </div>
    </div>
  </div> 
</template>

<script>
import Status from '@/components/Status'
import Lifetime from '@/components/Lifetime'
import Vibration from '@/components/Vibration'
import Temperature from '@/components/Temperature'

export default {
  name: 'dashboard',
  data () {
    return {
      msg: 'Welcome to Your MOZYS PWA'
    }
  },
  components: {
    mzStatus: Status,
    mzLifetime: Lifetime,
    mzVibration: Vibration,
    mzTemperature: Temperature
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue